import { Usuario } from '../model/usuario/usuario.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UsuarioLogado } from '../model/usuario/usuario-logado.model';
import { environment } from '../../../../environments/environment';
import {GrupoSelect} from '../model/grupo/grupo-select.model';
import {ConstantsUtils} from '../util/constants.utils';
import {MsgService} from './msg.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);
  private readonly jwtHelperService = inject(JwtHelperService);
  private readonly msgService = inject(MsgService);

  login(login: string, senha: string, grupoId: number | undefined): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('username', login);
    headers = headers.append('password', senha);
    headers = headers.append('grupo', grupoId ? grupoId.toString() : '');
    return this.http.get(`${environment.urlBase}/public/autenticar`, { headers });
  }

  redefinirSenha(email: string, grupoId: number): Observable<boolean> {
    const usuario = {
      email: email,
      grupoId: grupoId,
    }
    return this.http.post<boolean>(`${environment.urlBase}/public/redefinir-senha`, usuario);
  }

  trocarSenhaUsuario(email: string, grupoId: number, senha: string): Observable<boolean> {
    const usuarioEnvio = {
      email: email,
      grupoId: grupoId,
      senha: senha
    }
    return this.http.post<boolean>(`${environment.urlBase}/public/trocar-senha-usuario`, usuarioEnvio);
  }

  validarCodigo(email: string, grupoId: number, codigo: string): Observable<boolean> {
    const usuario = {
      email: email,
      grupoId: grupoId,
      codigoRedefinicao: codigo,
    }
    return this.http.post<boolean>(`${environment.urlBase}/public/validar-codigo-redefinicao`, usuario);
  }

  buscarGruposPeloEmailUsuario(email: string): Observable<GrupoSelect[]> {
    return this.http.get<GrupoSelect[]>(`${environment.urlBase}/public/grupo/${email}`);
  }

  logado(): boolean {
    return (
      localStorage.getItem('permissoesClariBot') != undefined &&
      localStorage.getItem('permissoesClariBot') != null &&
      this.checkTokenIsValid()
    );
  }

  getUsuarioLogado(): Usuario {
    const token = this.token();
    let decodedToken = null;
    if (token !== null && token !== undefined) {
      decodedToken = this.jwtHelperService.decodeToken(token);
    }

    const usuario: Usuario = new Usuario();
    usuario.id = +decodedToken?.id;
    usuario.nome = decodedToken?.nome;
    usuario.login = decodedToken?.login;
    usuario.perfis = decodedToken?.perfil;
    usuario.grupo = decodedToken?.grupo;
    usuario.prefixoGrupo = decodedToken?.prefixoGrupo;
    usuario.extensaoImg = decodedToken?.extensaoImg;
    usuario.isOperador = decodedToken?.isOperador;
    return usuario;
  }

  getUsuarioLogadoClariBot(): UsuarioLogado {
    const token = this.token();
    let decodedToken = null;
    if (token !== null && token !== undefined) {
      decodedToken = this.jwtHelperService.decodeToken(token);
    }
    let usuario: UsuarioLogado = new UsuarioLogado();
    usuario = decodedToken;
    return usuario;
  }

  logout(): void {
    localStorage.removeItem('tokenClariBot');
    localStorage.removeItem('permissoesClariBot');
    localStorage.removeItem('empresasClariBot');
    this.router.navigate(['']);
  }

  salvarUltimaRotinaAcessada(url: string): void {
    const idUsuario = this.getUsuarioLogado().id;
    if (idUsuario) sessionStorage.setItem(`ultimaRotinaAcessada_${idUsuario}`, url);
  }

  ultimaRotinaAcessada(): string {
    const idUsuario = this.getUsuarioLogado().id;
    return (idUsuario && sessionStorage.getItem(`ultimaRotinaAcessada_${idUsuario}`)) || '/index';
  }

  excluirToken() {
    localStorage.removeItem('tokenClariBot');
  }

  token(): string | null {
    return localStorage.getItem('tokenClariBot');
  }

  armazenarToken(jwt: any) {
    localStorage.setItem('tokenClariBot', jwt.idToken);
    const usuario = this.getUsuarioLogadoClariBot();
    if (usuario?.extensaoImg) {
      localStorage.setItem('extensaoImg', usuario.extensaoImg);
    }
  }

  buscarModulos(): Observable<any> {
    return this.http.get(`${environment.urlBase}/permissao-usuario`, {
      headers: { 'no-loading': 'true' },
    });
  }

  get getModulos():any {
    const permissoes = localStorage.getItem('permissoesClariBot');
    if (permissoes) {
      return JSON.parse(CryptoJS.AES.decrypt(permissoes, ConstantsUtils.SECRET_KEY).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  possuiAcessoRotina(url: string): boolean {
    if (url === 'index') {
      return true;
    }
    return (this.getModulos ?? []).some((mod: any) => (mod.rotinas ?? []).some((rot: any) => rot.url === url));
  }

  checkTokenIsValid() {
    return !this.jwtHelperService.isTokenExpired(this.token());
  }

  avisarSeTokenExpirou() {
    if (this.token() && !this.checkTokenIsValid()) {
      this.msgService.msgAdvertencia('Seu Token expirou!');
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
  }

  public static getEnumKey(enumType: any, enumValue: any): string {
    return Object.keys(enumType).find(x => enumType[x] == enumValue) || '';
  }
}
